import { render, staticRenderFns } from "./page15.vue?vue&type=template&id=040fa275&scoped=true&"
import script from "./page15.vue?vue&type=script&lang=js&"
export * from "./page15.vue?vue&type=script&lang=js&"
import style0 from "./page15.vue?vue&type=style&index=0&id=040fa275&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040fa275",
  null
  
)

export default component.exports